import { CreditPlan } from '@infura/key-service-sdk/lib/v1/proto/service_plan/v1/service'
import { KSService } from '@infura/packages.common/servicePlan'

export const getOnCreditPlan = (servicePlan?: KSService | null) =>
  (servicePlan?.creditPlan as unknown as CreditPlan) === CreditPlan.CREDITPLAN_CREDIT_UNITS

export const CREDIT_PACK_CREDITS = 55_000_000

// a temporary tier to support credit plan migration
export const CORE_CREDITS_TIER = 'core_credits'
